export default "__VITE_ASSET__DvO0dl0J__"